import { apiAdminInstance } from "../Api/ApiInstance";

export const ListFilterTransmition = async () => {
  return await apiAdminInstance.get(
    "api/nexus-main/transmition/filter"
  );
};
